<template>
    <button 
        role="button" 
        class="burger"
        aria-label="Open/close mobile menu" 
        @click.prevent="handleBurgerClick" 
        @keydown.space.prevent="handleBurgerClick" 
        @keydown.enter.prevent="handleBurgerClick" 
        :class="{open: isOpen}">
        <span></span>
    </button>
</template>
<script>

export default {
    name: 'GlobalBurger',
    expose: ['handleBurgerClick'],
    components: {
    },
    props: {
    },
    data() {
        return {
            isOpen: false,
        }
    },
    mounted() {
    },
    methods: {
        handleBurgerClick() {
            if (!this.isOpen) {
                document.querySelector('.menu').classList.add('open');
                document.querySelector('body').classList.add('menuOpen');
            } else {
                document.querySelector('.menu').classList.remove('open');
                document.querySelector('body').classList.remove('menuOpen');
            }
            this.isOpen = !this.isOpen;
        }
    }
}
</script>